// extracted by mini-css-extract-plugin
export default {"phoneText":"LoginWithPhoneOTP__phoneText___yM2f7","resendButton":"LoginWithPhoneOTP__resendButton___IR7ZX","skeleton-loading":"LoginWithPhoneOTP__skeleton-loading___vvibb"};